import axios from 'axios'
import type { MobileOtaUpdateDetail, MobileOtaUpdatesPage, OtaPlatform } from '@numeo/types-main-mobile'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const mobileOtaUpdatesApi = {
    async list(platform: OtaPlatform, cursor?: string): Promise<MobileOtaUpdatesPage> {
        const response = await axios.get<Envelope<MobileOtaUpdatesPage>>('/gluon/mobile-ota/updates/v1', { params: { platform, cursor } })
        return response.data.data
    },

    async get(releaseId: string): Promise<MobileOtaUpdateDetail> {
        const response = await axios.get<Envelope<MobileOtaUpdateDetail>>(`/gluon/mobile-ota/updates/${encodeURIComponent(releaseId)}/v1`)
        return response.data.data
    },
}
